<template>
    <table-template :queryParams="queryParams" actionUrl="/distributor/findDbtServiceConsumeRecords.action"
                    ref="consume-records">
        <template slot="search">
            <el-select @change="$refs['consume-records'].search()" clearable placeholder="请选择状态"
                       v-model="queryParams.type">
                <el-option :value="1" label="云服务包"></el-option>
                <el-option :value="2" label="线上充值"></el-option>
                <el-option :value="3" label="线下充值"></el-option>
                <el-option :value="4" label="维保查询"></el-option>
                <el-option :value="5" label="碰撞查询"></el-option>
                <el-option :value="6" label="商品活动"></el-option>
                <el-option :value="7" label="开通会员"></el-option>
                <el-option :value="8" label="续费会员"></el-option>
                <el-option :value="9" label="省心智联"></el-option>
                <el-option :value="10" label="注册新会员"></el-option>

            </el-select>

            <el-date-picker
                    @change="onCreateTimeChanged"
                    clearable
                    end-placeholder="创建时间截止"
                    range-separator="至"
                    start-placeholder="创建时间开始"
                    style="margin-left: 10px;"
                    type="datetimerange"
                    v-model="createTimeSearch">
            </el-date-picker>

            <el-input placeholder="用户账号" style="margin-left: 10px;width: 200px;"
                      v-model="queryParams.keyword"></el-input>
            <el-button @click="$refs['consume-records'].search()" style="margin-left: 10px;" type="primary">搜索
            </el-button>
        </template>

        <template slot="item">
            <el-table-column
                    label="编号"
                    prop="id">
            </el-table-column>
            <el-table-column
                    label="类型">
                <template scope="scope">
                    <span v-bind:style="{color:getTypeColor(scope.row.type)}">{{scope.row.type | typeFilter}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="支出云服务（次）"
                    prop="count">
            </el-table-column>
            <el-table-column
                    label="支出时间">
                <template scope="scope">
                    {{scope.row.createTime | dateTimeFormat}}
                </template>
            </el-table-column>
            <el-table-column
                    label="关联用户昵称"
                    prop="nickname">
            </el-table-column>
            <el-table-column
                    label="关联用户账号"
                    prop="memberPhone">
            </el-table-column>
        </template>
    </table-template>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'

export default {
  name: 'cloud-service-expenditure',
  data () {
    return {
      createTimeSearch: null,
      queryParams: {}
    }
  },
  components: { TableTemplate },
  filters: {
    typeFilter (value) {
      let filterValue = '暂无'
      switch (value) {
        case 1:// 云服务包
          filterValue = '云服务包'
          break
        case 2:// 线上充值
          filterValue = '线上充值'
          break
        case 3:// 线下充值
          filterValue = '线下充值'
          break
        case 4:// 线下充值
          filterValue = '维保查询'
          break
        case 5:// 碰撞查询
          filterValue = '碰撞查询'
          break
        case 6:// 商品活动
          filterValue = '商品活动'
          break
        case 7:// 开通会员
          filterValue = '开通会员'
          break
        case 8:// 续费会员
          filterValue = '续费会员'
          break
        case 9:// 省心智联
          filterValue = '省心智联'
          break
        case 10:// 注册新会员
          filterValue = '注册新会员'
          break
      }
      return filterValue
    }
  },
  methods: {
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
        this.$refs['consume-records'].search()
        return
      }
      this.queryParams.startTime = datetime[0].getTime()
      this.queryParams.endTime = datetime[1].getTime()
      this.$refs['consume-records'].search()
    },
    getTypeColor (status) {
      let color = ''
      switch (status) {
        case 1:// 云服务包
          color = '#409EFF'
          break
        case 2:// 线上充值
          color = '#67C23A'
          break
        case 3:// 线下充值
          color = '#E6A23C'
          break
        case 4:// 线下充值
          color = '#F56C6C'
          break
        case 5:// 碰撞查询
          color = '#909399'
          break
      }
      return color
    }
  }
}
</script>
